import {
    DEALERADDEDITDSR_SUCCESS,
    DEALERADDEDITDSR_FAILED,
    RESET_DEALERADDEDITDSR,
    LOADING_DEALERADDEDITDSR,
    NETWORK_ERROR_DEALERADDEDITDSR
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERADDEDITDSR:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERADDEDITDSR_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERADDEDITDSR_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERADDEDITDSR:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERADDEDITDSR:
            return (state = initialState);
        default:
            return state;
    }
};